import React from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import mark_your_attendance_1 from './../../../assets/onboarding/mark_your_attendance_1.svg'
import mark_your_attendance_2 from './../../../assets/onboarding/mark_your_attendance_2.svg'
import mark_your_attendance_3 from './../../../assets/onboarding/mark_your_attendance_3.svg'
import mark_your_attendance_4 from './../../../assets/onboarding/mark_your_attendance_4.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'flex-end',
  justifyContent: 'center',
  flexDirection: 'column'
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const mark_your_attendance_1_style = {
  position: "absolute",
  maxWidth: '90%',
  top: 20,
  left: 10
}

const mark_your_attendance_2_style = {
  position: "absolute",
  maxWidth: '90%',
  right: 10,
  marginTop: 40,
  zIndex: 99
}

const mark_your_attendance_3_style = {
  position: "absolute",
  left: 10,
  bottom: 25,
  maxWidth: '90%',
  zIndex: 99
}


const mark_your_attendance_4_style = {
  marginLeft: "-20px",
  maxWidth: '35%',
}

const Page4 = () => {
  const navigate = useNavigate();

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={mark_your_attendance_1} alt="" style={mark_your_attendance_1_style} />
        <img src={mark_your_attendance_2} alt="" style={mark_your_attendance_2_style} />
        <img src={mark_your_attendance_3} alt="" style={mark_your_attendance_3_style} />
      </UpperDiv>
      <LowerDiv style={lowerDivStyle}>
        <div className={classes.Page2Div}>
          <img src={mark_your_attendance_4} alt="" style={mark_your_attendance_4_style} />
          <h3 className={classes.Page2H3}>
            Mark Your Attendance
          </h3>
          <p className={classes.NameH3} style={{ fontSize: "16px" }}>
            Mark Your Attendance using CheckIn, CheckOut Button, make sure your Mobile Network,
            Camera and GPS Location is enabled or else you wont be able to mark your attendance.
          </p>
        </div>
        <div className={classes.Page2Pagination}>
          <div style={{ display: 'flex', width: "100%" }}>
            <button onClick={() => { navigate('/onboarding/3') }}>
              PREV
            </button>
            <button onClick={() => { navigate('/onboarding/5') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={4} />
        </div>
      </LowerDiv>
    </>
  )
}

export default Page4